import { getAuthMode } from './auth-mode';
import { getDevAccessToken, devRefreshTokens } from './dev-bypass-auth';
import { getMsalInstance, loginRequest } from './msal-config';
import { getSsoAccessToken, ssoRefreshTokens } from './sso-auth';

export async function getAccessToken(): Promise<string> {
  const mode = getAuthMode();

  if (mode === 'dev-bypass') {
    const token = getDevAccessToken();
    if (token) return token;
    await devRefreshTokens();
    return getDevAccessToken() ?? '';
  }

  if (mode === 'sso') {
    const token = getSsoAccessToken();
    if (token) return token;
    await ssoRefreshTokens();
    return getSsoAccessToken() ?? '';
  }

  const msalInstance = getMsalInstance();
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) return '';

  const account = accounts[0];
  if (!account) return '';

  try {
    const result = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
    });
    return result.accessToken;
  } catch {
    return '';
  }
}

export async function refreshTokens(): Promise<void> {
  const mode = getAuthMode();

  if (mode === 'dev-bypass') {
    await devRefreshTokens();
    return;
  }

  if (mode === 'sso') {
    await ssoRefreshTokens();
    return;
  }

  const msalInstance = getMsalInstance();
  const accounts = msalInstance.getAllAccounts();
  const account = accounts[0];
  if (!account) throw new Error('No accounts');

  await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account,
    forceRefresh: true,
  });
}
